
import TextEdition from '@/pages/service/TextEdition'
const Podcast = () => import(/* webpackChunkName: "podcast" */ '@/pages/service/podcast/Index');
const PodcastView = () => import(/* webpackChunkName: "podcast" */ '@/pages/service/podcast/View');
const Oracle = () => import(/* webpackChunkName: "oracle" */ '@/pages/service/oracle/Index');
const OracleView = () => import(/* webpackChunkName: "oracle" */ '@/pages/service/oracle/View');
const Hooked = () => import(/* webpackChunkName: "hooked" */ '@/pages/service/hooked/Index');
const HookedView = () => import(/* webpackChunkName: "hooked" */ '@/pages/service/hooked/View');
const EbookIndex = () => import(/* webpackChunkName: "ebook" */ '@/pages/service/ebook/Index');
const EbookView = () => import(/* webpackChunkName: "ebook" */ '@/pages/service/ebook/View');

const BookIndex = () => import(/* webpackChunkName: "book" */ '@/pages/service/book/Index');

const AudioIndex = () => import(/* webpackChunkName: "audio" */ '@/pages/service/audio/Index');

const SharebookIndex = () => import(/* webpackChunkName: "support" */ '@/pages/service/sharebook/Index');
const SharebookView = () => import(/* webpackChunkName: "support" */ '@/pages/service/sharebook/View');
const SharebookTag = () => import(/* webpackChunkName: "support" */ '@/pages/service/sharebook/Tag');

export default function (router) {
    // 路由配置
    router.addRoutes([
        { 
            path: '/service/:sid/text', 
            component: TextEdition,
            meta: {
                title: '文字版',
                dialog: true,
            } 
        },
        { 
            path: '/service/:sid/text/:id', 
            component: TextEdition,
            meta: {
                title: '文字版',
                dialog: true,
            } 
        },
        { 
            path: '/service/:sid/podcast', 
            component: Podcast,
            meta: {
                title: '播客',
                dialog: true,
            } 
        },
        { 
            path: '/service/:sid/podcast/:id', 
            component: PodcastView,
            meta: {
                title: '播客章节',
                dialog: true,
            } 
        },
        { 
            path: '/service/:sid/audio', 
            component: AudioIndex,
            meta: {
                title: '连续听',
                dialog: true,
            } 
        },
        { 
            path: '/service/:sid/hooked', 
            component: Hooked,
            meta: {
                title: '浩克春秋',
                dialog: true,
            } 
        },
        { 
            path: '/service/:sid/hooked/:id', 
            component: HookedView,
            meta: {
                title: '浩克章节',
                dialog: true,
            }
        },
        { 
            path: '/service/:sid/oracle', 
            component: Oracle,
            meta: {
                title: '六十四卦',
                dialog: false,
            }
        },
        { 
            path: '/service/:sid/oracle/:id', 
            component: OracleView,
            meta: {
                title: '卦相卦解',
                dialog: false,
            }
        },
        { 
            path: '/service/:sid/ebook', 
            component: EbookIndex,
            meta: {
                title: '电子书',
                dialog: true,
            }
        },
        { 
            path: '/service/:sid/ebook/:id', 
            component: EbookView,
            meta: {
                title: '电子书章节',
                dialog: true
            }
        },
        {
            path: '/service/:sid/sharebook',
            component: SharebookIndex,
            meta: {
                title: '推荐图书',
                dialog: true,
            }
        },
        {
            path: '/service/:sid/sharebook/category/:id',
            component: SharebookView,
            meta: {
                title: '推荐书目',
                dialog: true,
            }
        },
        {
            path: '/service/:sid/sharebook/tag/:id',
            component: SharebookTag,
            meta: {
                title: '推荐书目',
                dialog: true,
            }
        },
        {
            path: '/service/:sid/book',
            component: BookIndex,
            meta: {
                title: '图书',
                dialog: true,
            }
        },
    ]);
}